import React from 'react';
import { Header } from '../Header';
import { HoldingSplash } from '../HoldingSplash';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const Holding = _ref => {
  let {
    message,
    navLinks,
    children
  } = _ref;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: message ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Header, {
        navLinkGroup: navLinks !== null && navLinks !== void 0 ? navLinks : undefined
      }), /*#__PURE__*/_jsx(HoldingSplash, {
        message: message
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [" ", children]
    })
  });
};